
import qs from "qs";
import {Toast} from 'vant'
import codeKey from "@/components/Vsidentify.vue";

const CryptoJS = require("crypto-js")

function encrypt (data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {
  name: "Register",
  components: {codeKey},

  data() {

    return {
      loading: false, // 防止连续点击
      codeTest: this.$t('login.getCode'),
      code: 0,
      clients: {
        inviteCode: '',
        name: '', // 姓名公司名称
        userName: '', // 客户账户
        addr: '',
        password: '',
        newpwass: '',
        phone: '', // 手机号码
        email:'',
        uuid: '',
        verifyCode:''
      },
      passwordRules: [
        { required: true },
        { validator: this.validatePassword, message: this.$t('append_field.please_enter_password') }
      ],
      newpwassRules:[
          { required: true },
          { validator: this.validateNewpwass, message: this.$t('append_field.passwords_do_not_match') }
      ]
    }
  },
  mounted() {
    this.setUuid()
    document.title = this.$t('append_field.register')
  },
  methods: {
    validatePassword(value) {
      // 密码验证规则：至少8个字符，包含数字、字母和特殊字符[@#$%^&+=]
      const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/
      return passwordPattern.test(value)
    },
    validateNewpwass(value) {
      if(this.clients.password===value){
        return true
      }else {
        return false
      }
    },

    setUuid(newUuid) {
      this.clients.uuid = newUuid
    },
    onClickLeft(){
      this.$router.go("-1")
    },
    addManage () {
     if(this.clients.password!==this.clients.newpwass){
       Toast(this.$t('append_field.passwords_do_not_match'))
       return
     }
     this.$ajax({
            url: '/etv/registerPersoner.json',
            method: 'post',
            data: {
              userInfo: encrypt(JSON.stringify(this.clients)),
            },    //this.clients,
            cache: false,
            transformRequest: [function (data) {
              if (data instanceof FormData) {
                return data
              }
              data = qs.stringify(data)
              return data
            }],

          }).then(res => {
            if (res.data.code === 0) {
              Toast(res.data.msg)
              this.$router.replace("/login")
            } else {
              this.$refs.codeKey.getCode()
              Toast(res.data.msg)
            }
          })
    },
    back() {
      this.$router.back()
    },
  }
}
